import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchParams: {
    destinationPort: null, // { label, portIds } — a single port or a region's port_ids
    embarkationPort: null,
    month: "", // YYYY-MM, used as both start_date and end_date on /cruises/search
    cruiseLines: [], // selected cruise_name values for the /cruises/search cruise_lines field
    shipIds: [], // selected ship_id values for the /cruises/search cruise_ships_ids field
  },
  ports: [], // full port list from /cruises/ports
  lines: [], // full cruise line list from /cruises/lines
  ships: [], // full ship list from /cruises/ships
  isSearching: false, // true while /cruises/search is in flight
  results: null, // { count, data } from /cruises/search
  selectedCruise: null, // { id, session_id } from a /cruises/search result
  details: null, // /cruises/details response
};

const cruiseSearchSlice = createSlice({
  name: "cruiseSearch",
  initialState,
  reducers: {
    setCruiseSearchParams: (state, action) => {
      Object.assign(state.searchParams, action.payload);
    },
    setCruisePorts: (state, action) => {
      state.ports = action.payload;
    },
    setCruiseLines: (state, action) => {
      state.lines = action.payload;
    },
    setCruiseShips: (state, action) => {
      state.ships = action.payload;
    },
    setCruiseSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    setCruiseResults: (state, action) => {
      state.results = action.payload;
    },
    setSelectedCruise: (state, action) => {
      state.selectedCruise = action.payload;
      state.details = null;
    },
    setCruiseDetails: (state, action) => {
      state.details = action.payload;
    },
    resetCruiseSearch: () => initialState,
  },
});

export const {
  setCruiseSearchParams,
  setCruisePorts,
  setCruiseLines,
  setCruiseShips,
  setCruiseSearching,
  setCruiseResults,
  setSelectedCruise,
  setCruiseDetails,
  resetCruiseSearch,
} = cruiseSearchSlice.actions;

export default cruiseSearchSlice.reducer;
